import { Component } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { OverlayLoadingComponent } from "./components/overlay-loading/overlay-loading.component";
import { HTTP_INTERCEPTORS } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [IonRouterOutlet, IonApp, OverlayLoadingComponent],
})
export class AppComponent {}
